module.exports = __webpack_public_path__ + "img/c2-4.13c2d550.png";